/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { format } from "timeago.js";
import { FlexContainer, Text, theme } from "@nordcloud/gnui";
import { NotificationIcon } from "~/components";
import { NotificationItemWrapper } from "./styles";
import { Notification } from "./types";
import { mapNotificationStatus } from "./utils";

type Props = {
  notification: Notification;
};

export function NotificationItem({ notification }: Props) {
  const type = mapNotificationStatus(notification.type);
  return (
    <NotificationItemWrapper>
      <FlexContainer
        columnGap={theme.spacing.spacing02}
        css={{ width: "100%" }}
      >
        <NotificationIcon type={type} />
        <FlexContainer
          justifyContent="space-between"
          columnGap={theme.spacing.spacing02}
          css={{ width: "100%" }}
        >
          <Text nowrap mb={0} css={{ maxWidth: "25rem" }}>
            {notification.title}
          </Text>
          <Text mb={0} size="sm">
            {format(notification.createdAt)}
          </Text>
        </FlexContainer>
      </FlexContainer>
    </NotificationItemWrapper>
  );
}
